/* E-books Ressonância Curativa · eb-biblioteca.js (só a página /pages/lp-ebooks)
   Oferta (3 opções, escolha de e-books, diapasão adicional), checkout direto, barra fixa, avisos. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fmt = function (cents) {
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100); }
    catch (e) { return 'R$ ' + (cents / 100).toFixed(2).replace('.', ','); }
  };
  var ready = function (fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); };

  /* ---------- Oferta: 3 opções, escolha de e-books e diapasão adicional ---------- */
  function initOffer(el) {
    var data;
    try { data = JSON.parse(el.querySelector('[data-eb-offer-json]').textContent); } catch (e) { return; }
    var books = data.books || [];
    var state = { tier: data.default || 'kit', one: 0, two: books.length > 1 ? [0, 1] : [0], addon: false };
    var q = function (s) { return el.querySelector(s); };
    var rows = el.querySelectorAll('[data-eb-tier]');
    var addon = data.addon ? q('[data-eb-addon]') : null;
    var addonInput = addon ? addon.querySelector('input') : null;
    var sum = q('[data-eb-sum]');
    var btn = q('[data-eb-buy]');
    var err = q('[data-eb-err]');
    var sticky = document.querySelector('[data-eb-sticky="' + el.id + '"]');
    var txt = data.text || {};

    /* o que entra no carrinho e o que aparece na lista, conforme a opção marcada */
    function selection() {
      var lines = [], items = [], total = 0, old = 0;
      if (state.tier === 'one') {
        var b1 = books[state.one];
        if (b1) { lines.push({ name: b1.title + ' ' + (txt.pdf || ''), price: b1.one.price, old: data.full }); items.push(b1.one); total += b1.one.price; old += data.full; }
      } else if (state.tier === 'two') {
        state.two.forEach(function (i) {
          var b2 = books[i]; if (!b2) return;
          lines.push({ name: b2.title + ' ' + (txt.pdf || ''), price: b2.two.price, old: data.full }); items.push(b2.two); total += b2.two.price; old += data.full;
        });
      } else {
        var kit = data.tiers.kit, n = books.length || 1, each = kit.price % n === 0 ? kit.price / n : null;
        books.forEach(function (b3) { lines.push({ name: b3.title + ' ' + (txt.pdf || ''), price: each, old: data.full }); });
        items.push(kit); total += kit.price; old += kit.compare || data.full * n;
      }
      if (txt.delivery) lines.push({ name: txt.delivery, free: true });
      if (state.addon && data.addon) {
        lines.push({ name: data.addon.label, price: data.addon.price, old: data.addon.compare });
        if (data.addon.note) lines.push({ name: data.addon.note, plain: true });
        items.push(data.addon); total += data.addon.price; old += data.addon.compare || data.addon.price;
      }
      return { lines: lines, items: items, total: total, old: old };
    }

    function installment(cents) {
      var n = data.installments || 10, i = (data.rate || 0) / 100;
      if (!cents) return '';
      var pmt = i > 0 ? (cents / 100) * i / (1 - Math.pow(1 + i, -n)) : (cents / 100) / n;
      return n + 'x de ' + fmt(Math.round(pmt * 100));
    }

    function render() {
      var t = data.tiers[state.tier] || {};
      rows.forEach(function (row) {
        var key = row.getAttribute('data-eb-tier'), on = key === state.tier;
        row.classList.toggle('is-on', on);
        var inp = row.querySelector('input[type=radio]'); if (inp) inp.checked = on;
        var more = row.querySelector('[data-eb-more]'); if (more) more.hidden = !on;
        var pick = row.querySelector('[data-eb-pick]');
        if (pick) pick.querySelectorAll('[data-eb-book]').forEach(function (chip) {
          var i = parseInt(chip.getAttribute('data-eb-book'), 10);
          var sel = key === 'one' ? i === state.one : state.two.indexOf(i) > -1;
          chip.classList.toggle('is-on', sel); chip.setAttribute('aria-pressed', sel ? 'true' : 'false');
        });
      });
      if (addon) { addon.classList.toggle('is-on', state.addon); if (addonInput) addonInput.checked = state.addon; }
      var s = selection();
      if (sum) {
        sum.textContent = '';
        s.lines.forEach(function (l) {
          var li = document.createElement('li'), a = document.createElement('span'), b = document.createElement('span');
          a.textContent = l.name; li.appendChild(a);
          if (l.free) { b.className = 'is-free'; b.textContent = txt.free || 'GRÁTIS'; li.appendChild(b); }
          else if (l.plain) { li.className = 'is-note'; }
          else {
            if (l.old && (l.price === null || l.old > l.price)) { var o = document.createElement('s'); o.textContent = fmt(l.old); b.appendChild(o); }
            if (l.price !== null) { var v = document.createElement('b'); v.textContent = fmt(l.price); b.appendChild(v); }
            li.appendChild(b);
          }
          sum.appendChild(li);
        });
      }
      var set = function (sel, v) { var n = q(sel); if (n) n.textContent = v; };
      set('[data-eb-total]', fmt(s.total));
      var oldNode = q('[data-eb-total-old]'); if (oldNode) { oldNode.textContent = s.old > s.total ? fmt(s.old) : ''; }
      set('[data-eb-card]', installment(s.total) ? 'No cartão: ' + installment(s.total) + (data.rate ? ' (' + String(data.rate).replace('.', ',') + '%/parcela)' : '') : '');
      if (btn && !btn.classList.contains('is-loading')) btn.textContent = (t.cta || '') + ' · ' + fmt(s.total);
      if (sticky) {
        var sp = sticky.querySelector('[data-eb-sticky-price]'); if (sp) sp.textContent = fmt(s.total);
        var sn = sticky.querySelector('[data-eb-sticky-name]'); if (sn) sn.textContent = t.label || '';
      }
    }

    rows.forEach(function (row) {
      var key = row.getAttribute('data-eb-tier');
      var inp = row.querySelector('input[type=radio]');
      if (inp) inp.addEventListener('change', function () { if (inp.checked) { state.tier = key; render(); } });
      row.querySelectorAll('[data-eb-book]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var i = parseInt(chip.getAttribute('data-eb-book'), 10);
          if (key === 'one') { state.one = i; }
          else if (state.two.indexOf(i) === -1) { state.two.shift(); state.two.push(i); } /* sempre 2: o mais antigo sai */
          render();
        });
      });
    });
    if (addonInput) addonInput.addEventListener('change', function () { state.addon = !!addonInput.checked; render(); });

    function resolveVariant(t) {
      if (!t || !t.handle) return Promise.reject(new Error('Este produto ainda não está disponível para compra.'));
      return fetch(root + 'products/' + encodeURIComponent(t.handle) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('Produto indisponível no momento.'); return r.json(); })
        .then(function (p) {
          var vs = (p && p.variants) || [];
          var v = vs.find(function (x) { return String(x.id) === String(t.variant) && x.available; }) || vs.find(function (x) { return x.available; });
          if (!v) throw new Error('Produto esgotado no momento.');
          return String(v.id);
        });
    }

    function buy() {
      if (!btn || btn.classList.contains('is-loading')) return;
      var s = selection(), label = btn.textContent;
      if (!s.items.length) return;
      btn.classList.add('is-loading'); btn.textContent = 'Indo para o pagamento…';
      if (err) err.classList.remove('is-on');
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' })
        .catch(function () { return null; })
        .then(function () { return Promise.all(s.items.map(resolveVariant)); })
        .then(function (ids) {
          return fetch(root + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
          }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Não foi possível adicionar.'); return d; }); });
        })
        .then(function () { window.location.href = root + 'checkout'; })
        .catch(function (e) {
          btn.classList.remove('is-loading'); btn.textContent = label;
          if (err) { err.textContent = (e && e.message ? e.message + ' ' : '') + 'Tente de novo em instantes ou fale com a gente pela página de contato.'; err.classList.add('is-on'); }
        });
    }
    if (btn) btn.addEventListener('click', buy);
    if (sticky) {
      var sb = sticky.querySelector('[data-eb-sticky-buy]');
      if (sb) sb.addEventListener('click', function () {
        if (data.stickyScroll) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } else { buy(); }
      });
      var sec = el.closest('.eb-pageoffer') || el;
      var ticking = false;
      var check = function () {
        ticking = false;
        var r = sec.getBoundingClientRect();
        var offerVisible = r.top < window.innerHeight && r.bottom > 0;
        sticky.classList.toggle('is-on', window.scrollY > 300 && !offerVisible);
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    }
    render();
  }

  /* ---------- Avisos em pop-up ---------- */
  function initToast(el) {
    var items; try { items = JSON.parse(el.querySelector('[data-eb-toast-json]').textContent); } catch (e) { return; }
    if (!items || !items.length) return;
    var box = el.querySelector('.eb-toast'), i = 0;
    var first = parseInt(el.getAttribute('data-delay'), 10) || 12, gap = parseInt(el.getAttribute('data-gap'), 10) || 25;
    var closed = false;
    var x = box.querySelector('[data-close]');
    if (x) x.addEventListener('click', function () { box.classList.remove('is-on'); closed = true; });
    function show() {
      if (closed) return;
      var it = items[i % items.length]; i++;
      box.querySelector('[data-t]').textContent = it.t || '';
      box.querySelector('[data-s]').textContent = it.s || '';
      var img = box.querySelector('img'); if (img) { if (it.img) { img.src = it.img; img.hidden = false; } else { img.hidden = true; } }
      box.classList.add('is-on');
      clearTimeout(box._t);
      box._t = setTimeout(function () { box.classList.remove('is-on'); }, 5200);
      setTimeout(show, gap * 1000);
    }
    setTimeout(show, first * 1000);
  }

  /* ---------- Vídeos: toca ao tocar ---------- */
  function initVideos(root) {
    root.querySelectorAll('.eb-video video').forEach(function (v) {
      v.addEventListener('click', function () { v.muted = !v.muted; if (v.paused) v.play(); });
    });
  }

  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-eb-offer]').forEach(initOffer);
    scope.querySelectorAll('[data-eb-toasts]').forEach(initToast);
    initVideos(scope);
  }
  ready(function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
